export default __webpack_public_path__ + "static/media/auto.3058070e.svg";